import React, {useState} from "react";
import Login from "./Login";
import {useTranslation} from "react-i18next";
import AuthService from "../../services/auth.service";
import MessageBox from "../core/MessageBox";

export default function LoggedOut(props) {
    const {t} = useTranslation();

    const [showMessage, setShowMessage] = useState(true);

    // Clear both the user from local and redux storage
    AuthService.logout();
    AuthService.resetStore();

    setTimeout(() => setShowMessage(false), 5000);

    return (
        <>
            <Login/>
            {showMessage &&
                <div style={{width: '50rem', margin: 'auto'}}>
                    <MessageBox
                        title={'Information'}
                        message={t('loggedOut')}
                        colorClass={'canopia2'}
                    />
                </div>
            }
        </>
    );
}
